module.exports = __webpack_public_path__ + "static/media/map-marked.3c81b5d1.svg";